import React, { useState, useEffect } from "react";
//mui
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import Avatar from "@mui/material/Avatar";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { yellow } from "@mui/material/colors";
//狀態管理
import { observer } from "mobx-react-lite";
import emissionViewStore from "../../../Store/marco/emissionViewStore";
import { getConstByStandard } from "../../utils/getConstFileByStandard";

//翻譯
import { useTranslation } from "react-i18next";
//api
import { dataEntryAPI } from "../../API/dataEntryAPI";
import { emissionFactorAPI } from "../../API/emissionFactorAPI";
import { flattenEAFormData } from "../form/utils/toRequestBody";
import { handleEditEF } from "../utils/EFIncertController";
//main
const DataEntryUnitMismatchModal = observer(() => {
  const store = emissionViewStore;
  const CONST = getConstByStandard(store.standardId);
  const { t } = useTranslation("ActivityMain"); //之後要改
  const {
    selectedTab,
    _handleSetIsShowDataEntryUnitMismatchModal,
    EFCheckId,
    _handleSetEFCheckId,
    isShowDataEntryUnitMismatchModal,
    showEmissionActivityModal,
    EFFormData,
    showEmissionFactorEditModal,
    isShowEFIncertModal,
    EFIncertFormData,
    _handleSetLandEFCheckId,
  } = emissionViewStore;

  const { getUnitListFromEF } = emissionFactorAPI;

  const [unitOptions, setUnitOptions] = useState([]);
  const [unit, setUnit] = useState(0);
  //檢查按鈕是否可以點擊
  const [isSubmitting, setIsSubmitting] = useState(false);

  const category = CONST.category;
  const scope = category[selectedTab]?.split("_")[0]; //cat1

  const efTypeId = flattenEAFormData(EFFormData)["emissionFactorTypeId"]; // 結果會是 "1"
  const efId = flattenEAFormData(EFFormData)["emissionFactorId"];

  //取得EF下拉式單位清單資料
  const getOptions = async () => {
    let data;
    try {
      //////// 如果是EFInsertModal 要使用EFInsertFormData
      if (isShowEFIncertModal) {
        data = await getUnitListFromEF(
          EFIncertFormData.EFTypeId,
          EFIncertFormData.EFId,
        );
      } else {
        data = await getUnitListFromEF(efTypeId, efId); // 使用引入的 API 函數
      }

      console.log("EF下拉式單位清單資料:", data);
      setUnitOptions(data);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    if (EFCheckId) {
      getOptions();
    }
  }, [isShowDataEntryUnitMismatchModal]);

  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return; // // 阻止背景關閉
    }
    _handleSetIsShowDataEntryUnitMismatchModal(false);
    //_handleSetEFCheckId(""); //把ID歸零
  };

  //設定
  const settingUnit = async (id, unit, scope) => {
    //emissionViewStore._handleSetDataEntryListLoading(true);
    try {
      await dataEntryAPI.SetDataEntryAPI(id, "", unit, scope);
      return true; // 表示成功
    } catch (error) {
      console.error("Error data setting", error);
    } finally {
      emissionViewStore._handleSetDataEntryListLoading(false);
    }
  };

  //驗證功能&之後設定Unit的方法
  const handleSave = async () => {
    // 如果正在提交中，直接返回
    if (isSubmitting) return;
    setIsSubmitting(true); // 開始提交時設置標誌
    try {
      //////// 設定單位
      const settingSuccess = await store.setUnit(scope, EFCheckId, unit);
      // const settingSuccess = await settingUnit(
      //   EFCheckId,
      //   unit, //dataUnitId
      //   scope
      // );

      if (!settingSuccess) {
        // 如果添加失敗，不進行後續操作
        return;
      }

      _handleSetEFCheckId(""); //把ID歸零
      _handleSetLandEFCheckId(false);
      handleClose();
      ////////判斷是在排放活動頁面還是排放係數頁面
      if (showEmissionActivityModal === true) {
        await store.editEA();
      } else if (showEmissionFactorEditModal) {
        await store.editEF();
        await store.getEFListData({ keepPage: true });
      } else if (isShowEFIncertModal) {
        //////// insert 自動插入
        await handleEditEF();
      }

      setIsSubmitting(false);
      console.log("Mismatch Unit Setting:", unit);
    } catch (error) {
      console.error("Error in setting operation", error);
      setIsSubmitting(false); // 出錯時也要重新啟用
    }
  };

  return (
    <Dialog
      open={isShowDataEntryUnitMismatchModal}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-container": { zIndex: 9999 },
      }}
    >
      <DialogContent>
        <Stack
          direction="column"
          spacing={2}
          justifyContent="center"
          alignItems="center"
        >
          <Avatar sx={{ bgcolor: yellow[100], width: 56, height: 56 }}>
            <WarningRoundedIcon color="warning" fontSize="large" />
          </Avatar>
          <DialogContentText>
            {t("unitMismatchInfo")}
            {/* The emission factor and the data input unit are inconsistent, making
            it impossible to calculate the emission equivalent. Please reselect
            the emission factor or adjust the unit settings. */}
          </DialogContentText>
          <Grid container spacing={2} direction="row" sx={{ width: "100%" }}>
            <Grid size={4}>
              <Typography color="#696969" sx={{ marginBottom: 1 }}>
                <span style={{ color: "red" }}>*</span> {t("Choose Unit")}
              </Typography>
            </Grid>
            <Grid size={8}>
              <FormControl fullWidth size="small">
                <Select
                  value={unit}
                  onChange={(e) => setUnit(e.target.value)}
                  //未選擇時顯示Unset
                  displayEmpty
                  renderValue={(selected) => {
                    if (selected === "") {
                      return t("Unset");
                    }
                    const selectedOption = unitOptions.find(
                      (option) => option.unitId === selected,
                    );
                    return selectedOption
                      ? t(selectedOption.unitName)
                      : t("Unset");
                  }}
                  //文字顏色改深灰
                  sx={{ color: "#696969" }}
                >
                  {unitOptions.map((option) => (
                    <MenuItem key={option.unitId} value={option.unitId}>
                      {t(option.unitName)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{ bgcolor: "#e0e0e0", color: "#000", textTransform: "none" }}
        >
          {t("Close")}
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          disabled={isSubmitting}
          sx={{ textTransform: "none" }}
        >
          {isSubmitting ? t("Save...") : t("Save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default DataEntryUnitMismatchModal;
